import { ForwardedRef, useCallback } from 'react';

import { updateForwardedRef } from '@/utils/updateForwardedRef';

type RefCallback<T> = (node: T | null) => void;

export function useCombineRefs<T>(...refsToCall: ForwardedRef<T>[]): RefCallback<T> {
  const setRefs = useCallback(
    (node: T | null) => {
      refsToCall.forEach((r) => r && updateForwardedRef(r, node));
    },
    [refsToCall],
  );
  return setRefs;
}
